<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
           <a-col :span="12">
             <a-form-model-item :label="$t('报装申请时间')" prop="installationApplyTime">
               <a-date-picker :placeholder="$t('请选择报装申请时间')" valueFormat="YYYY-MM-DD" v-model="model.installationApplyTime"  style="width: 100%" />
             </a-form-model-item>
           </a-col>
           <a-col :span="12">
             <a-form-model-item :label="$t('勘察相约时间')" prop="investigationMeetTime">
               <a-date-picker :placeholder="$t('请选择勘察相约时间')" valueFormat="YYYY-MM-DD" v-model="model.investigationMeetTime"  style="width: 100%" />
             </a-form-model-item>
           </a-col>
           <a-col :span="12">
             <a-form-model-item :label="$t('勘察实际时间')" prop="investigationActualTime">
               <a-date-picker :placeholder="$t('请选择勘察实际时间')" valueFormat="YYYY-MM-DD" v-model="model.investigationActualTime"  style="width: 100%" />
             </a-form-model-item>
           </a-col>
           <a-col :span="12">
             <a-form-model-item :label="$t('安全状况')" prop="securityPosture">
               <a-input v-model="model.securityPosture" :placeholder="$t('请输入安全状况')"  ></a-input>
             </a-form-model-item>
           </a-col>
           <a-col :span="12">
             <a-form-model-item :label="$t('施工环境')" prop="constructionEnvironment">
               <a-input v-model="model.constructionEnvironment" :placeholder="$t('请输入施工环境')"  ></a-input>
             </a-form-model-item>
           </a-col>
           <a-col :span="12">
             <a-form-model-item :label="$t('日供水量')" prop="dailyWaterSupply">
               <a-input-number v-model="model.dailyWaterSupply" :placeholder="$t('请输入日供水量')" style="width: 100%" />
             </a-form-model-item>
           </a-col>
           <a-col :span="12">
             <a-form-model-item :label="$t('附件')" prop="annex">
               <a-upload name="file" :multiple="false" accept=".xlsx" :fileList="fileList" :headers="tokenHeader" :beforeUpload="beforeUpload" :remove="handleRemove">
                   <a-button>
                       <a-icon type="upload" />
                       {{ $t('选择附件') }}
                   </a-button>
               </a-upload>
             </a-form-model-item>
           </a-col>
           <a-col :span="12">
             <a-form-model-item :label="$t('图片')" prop="picture">
               <j-image-upload class="avatar-uploader" :text="$t('上传')" v-model="model.picture"></j-image-upload>
             </a-form-model-item>
           </a-col>
          </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import { httpAction, getAction, postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import Vue from 'vue'

  export default {
    name: 'ConstructionDetailForm',
    components: {
      JImageUpload
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-engineering/engineering/investigationDetail/add",
          edit: "/jeecg-engineering/engineering/investigationDetail/edit",
          queryById: "/jeecg-engineering/engineering/investigationDetail/queryById",
          next: "/jeecg-engineering/flowable/task/completeByDateId",
        },
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        fileList1: [],
        fileList2: [],
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        // this.model = Object.assign({}, record);
        this.model.installationId = record.id;
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            postAction(that.url.add,that.model).then(res=>{
              if(res.success){
                that.$message.success(res.message);
                let params = {
                  dataId: that.model.installationId,
                  values: {
                    dataId: that.model.installationId,
                    comment: ''
                  }
                }
                postAction(that.url.next,params).then((res)=>{
                  if(res.success){
                    that.$message.success(this.$t('操作成功'));
                    that.$emit('ok');
                  }else{
                    that.$message.warning(this.$t('操作失败'));
                  }
                });
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            });
          }
        })
      },
    }
  }
</script>
<style scoped>
  .avatar-uploader>.ant-upload {
    width: 104px;
    height: 104px;
  }
</style>